/*
  Matomo custom event tracking for theme interactions not covered by the
  base pageview tracker in snippets/head.matomo.liquid.

  Hooks used (confirmed against theme source, not guessed):
  - 'ajaxProduct:added' on document — dispatched by block.product-buy-buttons.js
    (PDP add-to-cart form), overlay.quick-add.js (quick-add modal), and
    usf.js (collection/search grid quick add). detail.product is either a
    single Shopify cart line item, or { items: [...] } depending on the
    submitter, so both shapes are handled below.
  - #downpay-buy-button — id targeted directly by the Downpay app block's
    own custom_css setting in templates/product.json, so it's stable.
  - Wishlist hearts (.ajm-wish) are tracked by assets/ajm-wishlist.js itself,
    which knows whether a tap was an add or a remove. (Until 2026-10-19 this
    file tracked Swym's button, whose internal add/remove state couldn't be
    reliably observed from outside, so this tracks button clicks rather
    than confirmed add/remove outcomes.
  - [data-newsletter-form] — attribute set in snippets/form.customer.liquid.
    The newsletter form is a full-page post/reload, so success is detected
    by checking for the server-rendered success message on page load.
*/

;(function () {
  window._paq = window._paq || []

  function trackEvent(category, action, name, value) {
    var evt = ['trackEvent', category, action]
    if (name !== undefined) evt.push(name)
    if (value !== undefined) evt.push(value)
    window._paq.push(evt)
  }

  function cartItemsFromProduct(product) {
    if (!product) return []
    if (Array.isArray(product.items)) return product.items
    return [product]
  }

  document.addEventListener('ajaxProduct:added', function (event) {
    var product = event.detail && event.detail.product
    cartItemsFromProduct(product).forEach(function (item) {
      if (!item) return
      var name = item.product_title || item.title
      var linePrice = typeof item.line_price === 'number' ? item.line_price : item.price * (item.quantity || 1)
      trackEvent('Ecommerce', 'Add to Cart', name, Math.round(linePrice) / 100)
    })
  })

  document.addEventListener('click', function (event) {
    if (event.target.closest('#downpay-buy-button')) {
      trackEvent('Downpay', 'Reserve with Deposit Click')
      return
    }

    // Wishlist hearts report their own Add / Remove events (assets/ajm-wishlist.js).
  })

  document.querySelectorAll('[data-newsletter-form] .note--success').forEach(function () {
    trackEvent('Newsletter', 'Subscribe Success')
  })
})()
